/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimeTrialCto } from '../../models/time-trial-cto';
import { TimeTrialExtensionRequestCto } from '../../models/time-trial-extension-request-cto';

export interface ExtendCompanyTimeTrial$Plain$Params {
  companyId: string;
      body?: TimeTrialExtensionRequestCto
}

export function extendCompanyTimeTrial$Plain(http: HttpClient, rootUrl: string, params: ExtendCompanyTimeTrial$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TimeTrialCto>> {
  const rb = new RequestBuilder(rootUrl, extendCompanyTimeTrial$Plain.PATH, 'post');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TimeTrialCto>;
    })
  );
}

extendCompanyTimeTrial$Plain.PATH = '/company/{companyId}/extendtimetrial';
